import {
	StyledBottomText,
	StyledContainer,
	StyledErrorText,
	StyledLightning,
} from './ErrorOverlay.styled';

const ErrorOverlay = () => {
	return (
		<StyledContainer>
			<StyledLightning $position="topLeft" />
			<StyledLightning $position="topRight" />
			<StyledLightning $position="bottomLeft" />
			<StyledLightning $position="bottomRight" />
			<StyledErrorText>ОШИБКА</StyledErrorText>
			<StyledBottomText>CCDPLANET CITY ENERGY SYSTEM 0.0.1</StyledBottomText>
		</StyledContainer>
	);
};

export { ErrorOverlay };
